<form
  [formGroup]="formData"
  novalidate
  (ngSubmit)="save()"
  [ngClass]="{ submitted: submitted }"
>
  <div class="modal-header">
    <h4 class="modal-title">Sync HubSpot Data</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body factory_admin">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <p>
            This function will download all companies and contacts out of HubSpot.
            By default it will only update information already synced in Luminous.
            If you want to create new records for data that isn't in Luminous make
            sure and check the following box.
          </p>
          <mat-checkbox formControlName="create_missing">
            Create missing records
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-default mr-1"
      type="button"
      (click)="activeModal.dismiss('')"
      >Cancel</button
    >
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="loading"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      >Submit</button
    >
  </div>
</form>
